// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M8 1.8C8.48 1.8 8.83 2.24 9.42 2.62C10.32 3.2 11.3 3.62 12.3 3.78C12.88 3.87 13.25 4.26 13.25 4.84V8C13.25 10.83 11.82 12.75 8.62 14.02C8.22 14.18 7.78 14.18 7.38 14.02C4.18 12.75 2.75 10.83 2.75 8V4.84C2.75 4.26 3.12 3.87 3.7 3.78C4.7 3.62 5.68 3.2 6.58 2.62C7.17 2.24 7.52 1.8 8 1.8Z',
  'M5.4 8.2L7 9.8L10.4 6.4',
];
